<script>
  // import axios from '../../axios'
  import { Bar } from 'vue-chartjs'

  export default {
    props: ['labels', 'data', 'tooltips'],
    extends: Bar,
    mounted () {
      this.loadGraphData()
    },
    watch: {
      data (newVal) {
        this.loadGraphData(newVal)
      }
    },
    data () {
      return {
        datacollection: {

          labels: [],
          datasets: []
        },

        options: {

          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [{
              gridLines: {
                display: false
              }
            }]
          },
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    methods: {
      loadGraphData (newVal = false) {

        this.datacollection.labels = this.labels

        let data = newVal ? newVal : this.data
        let key = 0;

        const colors = [
          {backgroundColor: 'rgba(0, 175, 239, 0.5)', borderColor: '#006fc0'},
          {backgroundColor: 'rgba(0, 111, 192, 0.5)', borderColor: '#00afef'},
        ]

        for (let i in data) {
          this.datacollection.datasets.push({
            label: this.$t('dashboard.' + i),
            backgroundColor: colors[key].backgroundColor,
            borderColor: colors[key].borderColor,
            borderWidth: 1,
            data: data[i]
          })
          key++;
        }
        this.renderChart(this.datacollection, this.options)
      }
    }
  }
</script>
